/**
 * main-slider
 */

import Page from '~/page/page';
import Keyframes from 'js/lib/keyframes';
import Slider from '~/slider/slider';

import $ from 'jquery';

export default class HeroSlider extends Slider {
  init() {
    const { animation = {} } = this.$.root.data('options') || {};

    const elements = {
      slider: '.js-hero-slider-slides',
      slide: '.js-hero-slider-slide',
      prev: '.js-hero-slider-prev',
      next: '.js-hero-slider-next'
    };

    const options = {
      arrows: false,
      fade: true,
      swipe: false,
      speed: 400,
      customPaging(slider, i) {
        return $(
          `<button data-index="${i}" type="button" class="js-hero-slider-dot" />`
        );
      }
    };

    this.animation = {
      duration: animation.duration || 800,
      offset: animation.offset || 400,
      easing: animation.easing || 'easeOutQuad'
    };

    this.set(elements, options);
    this.$.dot = this.$.root.find('.js-hero-slider-dot');
  }
  events() {
    this.$.prev.on('click', { type: 'PREV' }, e => this.handler(e));
    this.$.next.on('click', { type: 'NEXT' }, e => this.handler(e));
    this.$.dot.on('click', { type: 'GOTO' }, e => this.handler(e));
  }
  handler(e) {
    const type = e.data.type;
    const map = {
      PREV: () => this.go('slickPrev'),
      NEXT: () => this.go('slickNext'),
      GOTO: e => {
        e.preventDefault();
        e.stopPropagation();

        const $dot = $(e.target);
        const index = $dot.data('index');

        this.go('slickGoTo', index);
      }
    };

    map[type].call(this, e);
  }
  go(dir, index) {
    this.out().then(() => {
      if (index !== undefined) {
        this.$.slider.slick(dir, index, true);
      } else {
        this.$.slider.slick(dir);
      }
      this.in();
    });
  }
  in() {
    return new Promise(resolve => {
      Keyframes.getTimeline(this.getSlide(), this.animation).complete = () => {
        resolve();
      };
    });
  }
  out() {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve();
      }, 100);
    });
  }
  getSlide(target) {
    const index =
      target !== undefined ? target : this.$.slider.slick('slickCurrentSlide');
    return this.$.slide.eq(index);
  }
  mount() {
    this.hide();
    this.show().then(() => {
      this.in();
    });
  }
  hide() {
    const $slide = this.getSlide(0);
    const $elements = $slide.find('[data-animate]');

    $elements.css({ opacity: 0 });
  }
}

Page.mount(HeroSlider, '.js-hero-slider');
